import { z } from "zod";

import { idNameSchema } from "./generic-schema.ts";

// GET Request Schemas //
// Endpoint: /api/create-quote/freight-classes
export const freightClassSchema = idNameSchema.extend({
	code: z.string(),
});

export type FreightClass = z.infer<typeof freightClassSchema>;
